import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'

import globalStore from './global/store'
Vue.use(Vuex)
let store

function initStore () {
  store = new Vuex.Store({
    ...globalStore
  })
}

export default function () {
  if (!store) {
    initStore()
  }
  return store
}



// WEBPACK FOOTER //
// ./app/resource/store.js